export default {
  methods: {
    displaySnack(options) {
      //console.log("Displaying Snack");

      this.$refs.snackbar.display(
        {
          text: options.text,
          color: options.color
        }
      );
    }
  },
}